import cloudinary from 'cloudinary-core';
import merge from 'lodash/merge';

// @ts-expect-error ts-migrate(2351) FIXME: This expression is not constructable.
const cl = new cloudinary.Cloudinary({ cloud_name: 'dfkxpkzqx', secure: true });

// Get an Image from a remote URL
export const getImageURL = (url: $TSFixMe, options: $TSFixMe) => {
  const opt = merge(
    {
      type: 'fetch',
      fetchFormat: 'auto',
      dpr: window.devicePixelRatio,
    },
    options
  );

  if ((opt.width || opt.height) && !opt.crop) {
    opt.crop = 'fit';
  }

  return cl.url(url, opt);
};

// Get an Avatar from a remote URL
export const getAvatarURL = (url: $TSFixMe, options: $TSFixMe) => {
  const opt = merge(
    {
      type: 'fetch',
      fetchFormat: 'auto',
      dpr: window.devicePixelRatio,
      crop: 'fill',
      gravity: 'face',
    },
    options
  );

  return cl.url(url, opt);
};

// Get an Image from cloudinary media library
export const getImage = (url: $TSFixMe, options: $TSFixMe) => {
  const opt = merge(
    {
      fetchFormat: 'auto',
      dpr: window.devicePixelRatio,
    },
    options
  );

  if ((opt.width || opt.height) && !opt.crop) {
    opt.crop = 'lfill';
  }

  return cl.url(url, opt);
};
